export default {
  name: 'UserCommunities',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  methods: {
    gotoCommunity (idCommunity) {
      this.$router.push({ name: 'communityPage', params: { id: idCommunity } })
    }
  },
  computed: {
    leaderItems () {
      return this.items.filter(item => item.UserCommunity.isOwner).map(item => {
        return {
          name: item.name ? item.name.trim() : '',
          id: item.id
        }
      })
    },
    joinedItems () {
      return this.items.filter(item => !item.UserCommunity.isOwner).map(item => {
        return {
          name: item.name ? item.name.trim() : '',
          id: item.id
        }
      })
    }
  }
}
